import { Layout } from '../components/Layout';
import { GoogleAuthSetupForm } from '../components/GoogleAuthSetupForm';

export const GoogleAuthSetup = () => {
  return (
    <Layout title="Google Authenticator Setup">
      <GoogleAuthSetupForm />
    </Layout>
  );
};
